import { AUTH_REFRESH_TOKEN, AUTH_TOKEN } from "../../helpers/localStorage";

/*
SERVICE
This is the service for working with local storage and tokens.
AuthService should be used for working with the backend.
*/
class TokenService {
  storeAuthTokensInLocalStorage(token: string, refreshToken?: string) {
    if (token) {
      localStorage.setItem(AUTH_TOKEN, token);
    }

    if (refreshToken) {
      localStorage.setItem(AUTH_REFRESH_TOKEN, refreshToken);
    }
  }

  getLocalAccessToken() {
    return localStorage.getItem(AUTH_TOKEN);
  }

  getLocalRefreshToken() {
    return localStorage.getItem(AUTH_REFRESH_TOKEN);
  }

  removeTokens() {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(AUTH_REFRESH_TOKEN);
  }
}

export default new TokenService();
